import { Component, Input } from '@angular/core';
import { TYPES } from '../../../constants';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activity-type',
  standalone: true,
  imports: [TooltipModule, CommonModule],
  templateUrl: './activity-type.component.html',
  styleUrl: './activity-type.component.scss',
  /* Strategie auf Default geändert, damit Änderungen vom Service sofort sichtbar werden */
})
export class ActivityTypeComponent {
  @Input() typeName?: string;
  @Input() dbIcon?: string | null;
  @Input() dbColor?: string | null;

  types = TYPES;

  get icon(): string {
    //  Datenbank-Wert vom Service
    if (this.dbIcon) {
      if (this.dbIcon.endsWith('.png')) return this.dbIcon;
      return this.dbIcon
        .replace(/\bpi\b/g, '')
        .replace(/\s/g, '')
        .replace(/^-+/, '');
    }
    //  Statischer Fallback
    const clean = this.typeName?.replace(/\s/g, '') || '';
    const staticIcon = this.types[clean]?.icon || 'question-circle';
    return staticIcon
      .replace(/\bpi\b/g, '')
      .replace(/\s/g, '')
      .replace(/^-+/, '');
  }
  get color(): string {
    if (this.dbColor) return this.dbColor;
    const clean = this.typeName?.replace(/\s/g, '') || '';
    return this.types[clean]?.color || '#000';
  }
}
